import React, { useContext, createContext } from 'react';
export { default as UserInfo } from './UserInfoProvider.js';
import 'ramda';

const ModuleConfigContext = /*#__PURE__*/createContext();
function ModuleConfigProvider(_ref) {
  let {
    config = {},
    defaultConfig = {},
    ...restProps
  } = _ref;
  const configData = {
    ...defaultConfig,
    ...config
  };
  return /*#__PURE__*/React.createElement(ModuleConfigContext.Provider, {
    value: configData
  }, restProps.children);
}
function useModuleConfig() {
  const context = useContext(ModuleConfigContext);
  if (!context) {
    throw new Error('Module config Config provider is required');
  }
  return context;
}
const useWithModuleConfig = (ComponentToInject, modalConfigProps) => props => {
  return /*#__PURE__*/React.createElement(ModuleConfigProvider, modalConfigProps, /*#__PURE__*/React.createElement(ComponentToInject, props));
};
var ModuleConfigContext$1 = {
  ModuleConfigProvider,
  useModuleConfig,
  useWithModuleConfig
};

export { ModuleConfigContext$1 as ModuleConfig };
